import { useEffect, useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

const FALLBACK = {
  subscribers: "4,8k+",
  episodes: [
    { id: "_pRiLQmcdLA", title: "Une journée avec un DJ ➡️ Episode 101 ✅ On a mis le feu ! 🔥", published: "2026-08-17" },
    { id: "dZmeZcOLUAU", title: "Une Journée Avec un DJ ➡️ Episode 100 ✅ Un Mariage EXTRAORDINAIRE", published: "2026-07-24" },
    { id: "mpRDr-VE2FI", title: "Une journée avec un DJ ➡️ Episode 99 ✅ MARIAGE DE RÊVE MAIS IL FAIT TOUT BASCULER", published: "2026-07-01" },
    { id: "aSYmJrCDGuE", title: "Une journée avec un DJ ➡️ Episode 98 ✅ Un Mariage extraordinaire !", published: "2026-06-09" },
    { id: "6BtDEpAT-Dg", title: "Une journée avec un DJ ➡️ Episode 97 ✅ la grosse ERREUR ! 😱", published: "2026-04-20" },
  ],
};

let cache = null;

export const useYouTube = () => {
  const [data, setData] = useState(cache || FALLBACK);

  useEffect(() => {
    if (cache) return;
    axios
      .get(`${API}/api/youtube`)
      .then((r) => {
        cache = r.data;
        setData(r.data);
      })
      .catch(() => {});
  }, []);

  return data;
};
